module.exports = __webpack_public_path__ + "static/img/14areaB_2.4cb70ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/14areaB_2.png
// module id = 1116
// module chunks = 1